import { render, staticRenderFns } from "./Candidate.vue?vue&type=template&id=6e7c6244&scoped=true&"
import script from "./Candidate.vue?vue&type=script&lang=js&"
export * from "./Candidate.vue?vue&type=script&lang=js&"
import style0 from "./Candidate.vue?vue&type=style&index=0&id=6e7c6244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c6244",
  null
  
)

export default component.exports